import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import InputField from '../../../../../components/molecules/InputField';
import { getSecret, listSecrets } from '../../../_rego.service';
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers';

const FlowEditorSecrets = ({ secret_id }) => {
    const [showModal, setShowModal] = useState(false);
    const [secrets, setSecrets] = useState({});

    const initSecrets = async () => {
        const res = await getSecret(secret_id);
        setSecrets(res);
    };

    useEffect(() => {
        initSecrets();
    }, [secret_id]);

    const fieldTemplate = (variables) => {
        return Object.entries(variables).map(([key, value], index) => {
            return (
                <React.Fragment key={index}>
                    {typeof value !== 'object' && (
                        <li>
                            <div className='input-group input-group-sm'>
                                <span className='input-group-text border-gray-200 w-25 rounded-0'>
                                    {key}
                                </span>
                                <InputField
                                    defaultValue={value}
                                    config={{
                                        name: value,
                                        className: 'form-control-sm rounded-0 w-75 border-gray-200',
                                    }}
                                />
                            </div>
                        </li>
                    )}
                    {typeof value === 'object' &&
                        !Array.isArray(value) &&
                        !['dev', 'uat', 'prod'].includes(key) && (
                            <li>
                                <h6 className='bg-light-info border fs-8 p-2 my-2 text-info'>
                                    <div className='d-flex align-items-center justify-content-between w-100'>
                                        <div className='w-50px me-5'>
                                            <img
                                                alt={``}
                                                className='w-100'
                                                src={toAbsoluteUrl(`/assets/logos/${key}.png`)}
                                            />
                                        </div>
                                        <h5 className='fs-8 mb-0'>{key}</h5>
                                    </div>
                                </h6>
                                <ul>{fieldTemplate(value)}</ul>
                            </li>
                        )}
                </React.Fragment>
            );
        });
    };

    return (
        <>
            <OverlayTrigger
                placement='top'
                overlay={<Tooltip>Edit Secrets</Tooltip>}>
                <button
                    className={clsx(
                        `btn btn-icon btn-xs shadow shadow-sm border me-2 border-gray-400 border-dotted`
                    )}>
                    <i
                        className='ki-duotone ki-shield fs-3'
                        onClick={() => setShowModal(true)}></i>
                </button>
            </OverlayTrigger>
            <Modal
                show={showModal}
                dialogClassName='modal-custom w-90'
                onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Secrets</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <div>
                            <ul className='tree'>
                                <>{fieldTemplate(secrets?.value || {})}</>
                            </ul>
                        </div>
                    </>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant='secondary'>Close</Button>
                    <Button variant='primary'>Update Secrets</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
export default FlowEditorSecrets;
